import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Button from './Button.js';

/**
 * List page header — compact title + back button on mobile; full title on md+.
 * Action buttons stay compact (icon-only via Button mobileIconOnly).
 */
const ListPageHeader = ({
  title,
  icon: Icon,
  subtitle,
  iconClassName = 'w-6 h-6 shrink-0 text-buttonhoverTxt',
  titleClassName = 'text-gray-700',
  className = 'mb-4 sm:mb-6',
  actionsClassName = '',
  backTo,
  showMobileIcon = false,
  children,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
      return;
    }
    navigate(-1);
  };

  return (
    <div className={`flex items-center justify-between gap-2 min-w-0 ${className}`}>
      {/* Mobile: back + compact title */}
      <div className="flex items-center gap-1.5 min-w-0 flex-1 md:hidden">
        <Button
          variant="ghost"
          onClick={handleBack}
          className="p-1 -ml-1 shrink-0 rounded-lg"
          aria-label="Go back"
        >
          <ChevronLeft className="w-5 h-5 text-gray-700" />
        </Button>
        <h1 className={`text-sm font-semibold truncate flex items-center gap-1.5 min-w-0 ${titleClassName}`}>
          {Icon && showMobileIcon ? <Icon className="w-4 h-4 shrink-0 text-buttonhoverTxt" /> : null}
          <span className="truncate">{title}</span>
        </h1>
      </div>

      {/* Desktop / tablet: full title */}
      <div className="hidden md:flex min-w-0 flex-1 flex-col justify-center">
        <h1 className={`text-xl font-bold flex items-center gap-2 sm:gap-3 min-w-0 ${titleClassName}`}>
          {Icon ? <Icon className={iconClassName} /> : null}
          <span className="truncate">{title}</span>
        </h1>
        {subtitle ? <p className="text-sm text-gray-600 mt-1">{subtitle}</p> : null}
      </div>

      {children ? (
        <div
          className={`flex flex-row flex-wrap items-center justify-end gap-1.5 md:gap-3 shrink-0 ${actionsClassName}`}
        >
          {children}
        </div>
      ) : null}
    </div>
  );
};

export default ListPageHeader;
